/* 🤖 this file was generated by svg-to-ts */
export const emperorIconCheck: {
  name: 'check';
  data: string;
} = {
  name: 'check',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M9.00039 16.2001L4.80039 12.0001L3.40039 13.4001L9.00039 19.0001L21.0004 7.0001L19.6004 5.6001L9.00039 16.2001Z"/></svg>`,
};
